import styled from 'styled-components'
import { ItemContainer } from '../../styles'

export const Container = styled(ItemContainer)`
  margin-bottom: 32px;
`
